var _rect, _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSosAlertModalLight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 76,
    rx: 38,
    fill: "#FFC6C6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 30,
    fill: "#FF8787"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 24,
    fill: "#FF2124"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3848 34.3783C23.3848 32.2414 23.8105 30.2536 24.6618 28.415C25.5135 26.5764 26.6712 24.9893 28.1348 23.6538L29.2598 24.8783C27.9564 26.0578 26.9292 27.4606 26.1781 29.0867C25.427 30.7128 25.0514 32.4767 25.0514 34.3783H23.3848ZM50.9489 34.3783C50.9489 32.4767 50.5734 30.7074 49.8223 29.0704C49.0712 27.4338 48.0439 26.0257 46.7406 24.8462L47.8656 23.6538C49.3292 24.9893 50.4869 26.5764 51.3385 28.415C52.1899 30.2536 52.6156 32.2414 52.6156 34.3783H50.9489ZM26.3335 49.2821V47.6154H29.026V34.4104C29.026 32.2329 29.715 30.3178 31.0931 28.665C32.4714 27.0122 34.2182 25.9829 36.3335 25.5771V24.6667C36.3335 24.2072 36.4964 23.8146 36.8223 23.4887C37.1481 23.1629 37.5407 23 38.0002 23C38.4596 23 38.8523 23.1629 39.1781 23.4887C39.5039 23.8146 39.6669 24.2072 39.6669 24.6667V25.5771C41.7821 25.9829 43.5289 27.0122 44.9073 28.665C46.2853 30.3178 46.9743 32.2329 46.9743 34.4104V47.6154H49.6669V49.2821H26.3335ZM38.0002 53.6408C37.2544 53.6408 36.6192 53.3786 36.0948 52.8542C35.57 52.3297 35.3077 51.6946 35.3077 50.9488H40.6927C40.6927 51.6946 40.4303 52.3297 39.9056 52.8542C39.3812 53.3786 38.746 53.6408 38.0002 53.6408ZM30.6927 47.6154H45.3077V34.4104C45.3077 32.3846 44.5962 30.6601 43.1731 29.2371C41.75 27.814 40.0257 27.1025 38.0002 27.1025C35.9746 27.1025 34.2503 27.814 32.8273 29.2371C31.4042 30.6601 30.6927 32.3846 30.6927 34.4104V47.6154Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSosAlertModalLight);
export default __webpack_public_path__ + "static/media/sos-alert-modal-light.6366f44add8c49090ffa12ab09cd6771.svg";
export { ForwardRef as ReactComponent };